import { of } from 'rxjs';

export class Logo {

    private config = {
        logoUri: '../assets/images/shared/logo_1.svg'
    }
    load(music: string) {
        const build = (o, l, a, r) => {
            const body = document.querySelector('body');
            o.appendChild(l)
            body.appendChild(o);
            setTimeout(() => {
                o.append(a);
            }, 1000);
            setTimeout(() => {
                o.append(r);
            }, 1200);
        }
        const overlay = () => {
            let el = document.createElement('div');
            el.style.position = 'absolute';
            el.style.left = '0';
            el.style.top = '0';
            el.style.width = '100%';
            el.style.height = '100%';
            el.style.background = 'linear-gradient(160deg, #070707 40%, #a700004f 100%)';
            el.style.backgroundColor = '#070707';
            el.style.zIndex = '90';
            el.style.fontFamily = 'Teko';
            el.classList.add('overlay');
            return el;
        }

        const logo = () => {
            let el = document.createElement('img');
            el.src = `${this.config.logoUri}`;
            el.style.position = 'absolute';
            el.style.left = '0';
            el.style.top = '0';
            el.style.right = '0';
            el.style.bottom = '0';
            el.style.margin = 'auto';
            el.style.filter = 'drop-shadow(0px 0px 120px rgba(167, 0, 0, 0.2))';
            el.style.width = '250px';
            el.classList.add('fade-in');
            return el;
        }

        const ani = () => {
            let el = document.createElement('div');
            el.innerHTML = 'ANI';
            el.style.position = 'absolute';
            el.style.left = '0';
            el.style.top = '100px';
            el.style.right = '350px';
            el.style.bottom = '0';
            el.style.margin = 'auto';
            el.style.width = 'fit-content';
            el.style.height = 'fit-content';
            el.style.fontSize = '150px';
            el.classList.add('fade-in-2');
            return el;
        }

        const ryu = () => {
            let el = document.createElement('div');
            el.innerHTML = 'RYU';
            el.style.position = 'absolute';
            el.style.left = '370px';
            el.style.top = '100px';
            el.style.right = '0';
            el.style.bottom = '0';
            el.style.margin = 'auto';
            el.style.width = 'fit-content';
            el.style.height = 'fit-content';
            el.style.fontSize = '150px';
            el.style.color = 'rgb(167, 0, 0)';
            el.classList.add('fade-in-2');
            return el;
        }

        const o = overlay();
        const l = logo();
        const a = ani();
        const r = ryu();
        const m: HTMLAudioElement = <HTMLAudioElement>document.getElementById(music);
        const listener = document.addEventListener('mousemove', () => {
           // m.play();
            return;
        });
        build(o, l, a, r);

        return of(listener);
    }
}